/** Reloads the page. Its own module, so a test can mock it: jsdom's `location.reload` can't be replaced. */
export function reloadPage(): void {
  window.location.reload();
}
